import { cdn } from "core/cdn"
import { languages } from "locales/languages"

import { ACTION,Reply, Step} from "../Survey/types"
import { SMS_LINK } from "./services/constants"

export const ITEMS_PER_CAROUSEL_PAGE = 6
export const SECOND_NEXT_ANSWER = 0.2
export const PATH_DEEP = ":"

export enum PATH {
   SmsLink = "SmsLink",
   Qrcode = "Qrcode",
   Success= "Success"
}

const keppGoing: Reply[] =
[{
    title: languages.uploadDocumentSuccessButton,
    action: ACTION.redirect,
    value: true,
    ui: {
      view: "button",
      type: "primary"
    },
  }]

const cannotScanQrCode : Reply =
{
      title: languages.UDCannotScan,
      value: SMS_LINK,
      ui: {
        view: "button",
      },
}

const smsLinkReplies: Reply[] = [
  {
    title: languages.UDGetLinkBySms,
    value: SMS_LINK,
    ui: {
      view: "button",
    },
  },
]

const SmsLink : Step =
  {
  title: languages.UDAskSms,
  imgUrl: "",
  id: PATH.SmsLink,
  replies: smsLinkReplies,
}

export const QrcodeStep : Step =
  {
  title: languages.uDocScanQrCode,
  imgUrl: "",
  id: PATH.Qrcode,
  replies: [],
  defaultReply: cannotScanQrCode,
  }

const Success : Step =
  {
  title: languages.uploadDocumentSuccess,
  imgUrl: cdn("images/okay_illustration.svg"),
  id: PATH.Success,
  replies: keppGoing,
  }

export const UPLOAD_STEPS = [
  QrcodeStep,
  Success,
  SmsLink
]
